import React from 'react';
import PropTypes from 'prop-types';

function ProfileImage({ id, type, pictureUrl, ...props }) {
	const url = new URL(process.env.REACT_APP_IMAGE_EMBEDDING_URL);
	url.pathname = `profile/${type}/${id}`
	
	return (

		<img
			src={url}
			alt=""
			{...props}
			referrerPolicy="no-referrer"
			onError={(e) => {
				e.target.onerror = null;
				e.target.src = (e.currentTarget.src === url.href) ? pictureUrl : require(`assets/img/icons/url_icons/${type}.png`);
			}}
		/>
	);
}

ProfileImage.propTypes = {
	alt: PropTypes.string,
	id: PropTypes.string,
	type: PropTypes.string.isRequired
};

export default ProfileImage;
